import { networkRequestStatusReducer } from 'actions/network/reducer'
import { displayPoliticiansReducer } from 'components/chartSwitch/reducer'
import { demographicsReducer } from 'components/demographics'
import { filterReducer } from 'components/filter'
import { answers } from 'components/question'
import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'
import { readerAnswersReducer } from 'sagas/downloadFromFirebase/reducer'
import { StateType } from 'typesafe-actions'

const createRootReducer = (history: any) =>
  combineReducers({
    answers,
    demographics: demographicsReducer,
    displayPoliticians: displayPoliticiansReducer,
    downloadStatus: networkRequestStatusReducer('download'),
    filter: filterReducer,
    readerAnswers: readerAnswersReducer,
    router: connectRouter(history),
    uploadStatus: networkRequestStatusReducer('upload')
  })

export type RootState = StateType<ReturnType<typeof createRootReducer>>
export default createRootReducer
